module.exports = __webpack_public_path__ + "static/media/img1.4ed329a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/img1.png
// module id = 134
// module chunks = 0